import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { ModelRangeGNA } from '../../../models/model-range-range.model';

@Component({
    selector: 'app-model-range-gna-edit',
    templateUrl: './model-range-gna-edit.component.html',
    styleUrls: ['./model-range-gna-edit.component.scss']
})
export class ModelRangeGnaEditComponent implements OnInit {

    @Input() modelRangeGNA: ModelRangeGNA;
    @Input() modelRangeGNAForm: FormGroup;
    @Input() nameMachine: string;
    @Input() isAmount: boolean;
    @Input() type: 'create' | 'edit' | 'form' = 'create';

    private _form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private loadService: LoaderService,
    ) { }

    ngOnInit(): void {
    
    }

    get form(): FormGroup {
        if (this.type === 'form') {
            this._form = this.modelRangeGNAForm;
        } else {
            if (!this._form) {
                this._form = this.fb.group(
                    {
                        id: [this.modelRangeGNA?.id],
                        description: [this.modelRangeGNA?.description ? this.modelRangeGNA?.description : '', [Validators.required]],
                        inicialN: [this.modelRangeGNA?.inicialN ? this.modelRangeGNA?.inicialN : '', [Validators.required]],
                        finalN: [this.modelRangeGNA?.finalN ? this.modelRangeGNA?.finalN : '', [Validators.required]]
                    }
                );
            }
        }
        return this._form;
    }

    get formRaw(): ModelRangeGNA {
        return this._form.getRawValue();
    }

    get valid(): boolean {
        return this._form.valid;
    }

}
